import {Ajax} from './ajax';

const LOADING_PROGRESS = '<p class="x-loading-progress x-loading">Зареждане</p>';

export function execute<T, R>(elem: HTMLElement, executableCallback: Ajax.Callbacks<T, R>): Ajax.Callbacks<T, R> {
  if (!elem.innerHTML) {
    elem.innerHTML = LOADING_PROGRESS;
    executableCallback.setDefaultFailureListener(() => { elem.innerHTML === LOADING_PROGRESS && (elem.innerText = 'Проблем при зареждане'); });
  } else {
    elem.classList.add('x-loading');
    executableCallback.onComplete(() => { elem.classList.remove('x-loading'); })
  }
  return executableCallback.minExecMs(500);
}